import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from 'contexts';
import { NavPages, NavUtils } from 'utils';

interface Props {
    eventAlias?: string;
}

export const PrivateRoute = (props: Props) => {
    const { currentUser } = useAuth();

    if (currentUser) {
        return <Outlet />;
    }
    const safePathname = encodeURI(window.location.pathname);
    const loginUrl = `${NavUtils.generateNavPath(NavPages.Login, undefined, props.eventAlias)}${
        safePathname.length > 1 ? `?returnUrl=${safePathname}` : ''
    }`;

    return <Navigate to={loginUrl} replace />;
};
